import API from '../Services/API';
import Model from './Model';
import State from './State';

const useCalendar = (week, alwaysRefresh) => {
    return Model({
        alwaysRefresh: alwaysRefresh,
        returnDataKey: 'calendar',
        stateKey: ['calendar', week],
        fetchData: async () => API.get('/calendar?week=' + (week ?? '')),
        saveAdditionalData: (calendar) => {
            if (calendar.jobs) {
                calendar.jobs.forEach(job => {
                    State.put(['job', job.id], job)
                    if (job.customer) {
                        State.put(['customer', job.customer.id], job.customer)
                    }
                })
            }
            if (calendar?.appointments?.appointments ?? null) {
                Object.values(calendar.appointments.appointments).forEach(appointments => {
                    appointments.forEach(appointment => {
                        if (appointment.job) {
                            State.put(['job', appointment.job.id], appointment.job)
                        }
                        if (appointment.customer) {
                            State.put(['customer', appointment.customer.id], appointment.customer)
                        }
                    });
                });
            }
        },
        registerAdditionalMethods: (opts) => {
            return {
                generateWeek: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/calendar/generateWeek', data),
                        'Fill week',
                        true,
                    );
                },
                confirmAppointments: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/calendar/appointments/confirm', data),
                        'Appointments confirmed',
                        true,
                    );
                },
                completeAppointments: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/calendar/appointments/complete', data),
                        'Jobs marked as done',
                        true,
                    );
                },
                clearAppointments: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/calendar/appointments/clear', data),
                        'Calendar cleared',
                        true,
                    );
                },
                addMissingAppointments: (data) => {
                    return opts.wrapUpdateCall(
                        () => API.post('/calendar/appointments/addMissing', data),
                        'Route re-planned',
                        true,
                    );
                }
            }
        },
        defaultLoadingError: 'Sorry, there was an error loading the calendar.',
    });
}

const appointmentClasses = {
    'Invalidated': 'bg-gray-500/40 border border-1 border-dashed border-orange-600 text-white',
    'Tentative': 'bg-brand-light border border-1 border-dashed border-brand text-white',
    'Scheduled': 'bg-brand/80 text-white',
    'Scheduled Manually': 'bg-blue-900/80 text-white',
    'Late': 'bg-red-600/80 text-white',
    'Cancelled': 'bg-slate-600/80 text-white',
    'Complete': 'bg-cyan-600/80 text-white',
}

export {
    useCalendar,
    appointmentClasses,
};
